export function testNumberString(input: string): boolean {
  // check to see if input is any form of phone number
  // do not care if valid
  const strippableChars = ['-', '(', ')', ' '];
  const stripPattern = `[${strippableChars.join('|')}]`;
  const stripRegex = new RegExp(stripPattern, 'g');
  const numberRegex = /^\d+$/;

  const strippedString = input.replace(stripRegex, '');
  return numberRegex.test(strippedString);
}
